import { PriceService } from "./priceService.model";

export class PriceDVGT {
    boxId?: number;
    code?: string;
    name?: string;
    vSEOracleCode?: string;
    serviceId?: number;
    totalPrice?: number;
    pricePayment?: number;
    isAgree?: boolean;
    isSenderPaid?: boolean = false;
    priceServiceCode?: string;
    serviceName?: string;
    numberOfTransportations?: NumberOfTransportation[] = [];
    numberOfTransPromotion?:any[]=[];
}

export class NumberOfTransportation {
    priceServices: PriceService[] = [];
}